import { createContext } from "react";

export const NecessaryDataFetchingStatus = createContext<
  "pending" | "rejected" | "done"
>("pending");
export const SetNecessaryDataFetchingStatus = createContext<
  React.Dispatch<React.SetStateAction<"pending" | "rejected" | "done">>
>(() => {});
